import React from 'react';
import { Card, CardBody, CardText } from 'reactstrap';
import lokpalImage from '../assets/Lokpal.jpg';

export default function Ombudsman() {
    return (
        <div className="container mt-5 d-flex justify-content-center align-items-center flex-column">
            <h2
                className="fw-bold text-center mb-4"
                style={{
                    color: '#77236b',
                    fontSize: '2.5rem',
                    textShadow: '1px 1px 2px #ccc',
                }}
            >
                लोकपाल
            </h2>

            <Card
                className="border-0 shadow-lg p-4"
                style={{
                    maxWidth: '900px',
                    width: '100%',
                    borderRadius: '25px',
                    background: 'linear-gradient(145deg, #ffffff, #f5f5f5)',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                }}
            >
                <div className="d-flex flex-column flex-md-row align-items-center">
                    <img
                        src={lokpalImage}
                        alt="प्रो. अनुला मौर्य"
                        style={{
                            height: '220px',
                            width: '180px',
                            objectFit: 'cover',
                            border: '6px solid #77236b',
                            boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
                            marginBottom: '20px',
                            marginRight: '40px',
                        }}
                        className="mb-3 mb-md-0"
                    />

                    <CardBody className="text-center text-md-start">
                        <h3 className="fw-bold text-dark mb-3">प्रो. अनुला मौर्य</h3>
                        <CardText className="text-muted" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                            <strong>📍 कार्यालय:</strong><br />
                            अस्थाई परिसर - डॉ. भीम राव अम्बेडकर राजकीय महाविद्यालय,<br />
                            जगदीशपुरा, कैथल (हरियाणा) - 136027
                            <br /><br />
                            <strong>✉️ ई-मेल:</strong><br />
                            <a
                                href="mailto:anulamaurya@gmail.com"
                                className="text-decoration-none text-dark fw-semibold"
                                style={{ wordBreak: 'break-all' }}
                            >
                                anulamaurya@gmail.com
                            </a>
                        </CardText>
                    </CardBody>
                </div>
            </Card>
        </div>
    );
}
